import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';

function AppointmentForm() {
  const { handleAPICall } = useAuth();
  const [formData, setFormData] = useState({
    patientId: '',
    staffId: '',
    type: '',
    date: '',
    time: '',
    location: 'clinic',
    notes: '',
    apiType: 'appointments'
  });

  const [errors, setErrors] = useState({
    patientId: false,
    staffId: false,
    type: false,
    date: false,
    time: false
  });

  const validateForm = () => {
    const newErrors = {
      patientId: !formData.patientId,
      staffId: !formData.staffId,
      type: !formData.type,
      date: !formData.date,
      time: !formData.time
    };
    setErrors(newErrors);
    return !Object.values(newErrors).some(error => error);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    try {
      await handleAPICall({
        ...formData,
        datetime: `${formData.date}T${formData.time}:00.000Z`
      });
      setFormData({
        patientId: '',
        staffId: '',
        type: '',
        date: '',
        time: '',
        location: 'clinic',
        notes: '',
        apiType: 'appointments'
      });
    } catch (error) {
      console.error('Appointment submission failed:', error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors(prev => ({ ...prev, [name]: false }));
  };

  return (
    <form 
      onSubmit={handleSubmit}
      className="p-5 bg-white rounded-4 shadow-lg mt-5"
      style={{ maxWidth: '', margin: '0 auto' }}
    >
      <h2 className="mb-2 text-primary text-center fw-bold">Schedule Appointment</h2>
      
      <div className="row g-4 mb-2">
        <div className="col-md-6">
          <div className="form-group">
            <label className="form-label text-muted mb-2">Select Patient *</label>
            <select
              name="patientId"
              value={formData.patientId}
              onChange={handleChange}
              className={`form-select border-bottom border-light py-2 w-100 ${errors.patientId ? 'is-invalid' : ''}`}
            >
              <option value="">Choose patient...</option>
              <option value="1">Patient 1</option>
              <option value="2">Patient 2</option>
            </select>
          </div>
        </div>
        
        <div className="col-md-6">
          <div className="form-group">
            <label className="form-label text-muted mb-2">Select Staff *</label>
            <select
              name="staffId"
              value={formData.staffId}
              onChange={handleChange}
              className={`form-select border-bottom border-light py-2 w-100 ${errors.staffId ? 'is-invalid' : ''}`}
            >
              <option value="">Choose staff member...</option>
              <option value="1">Dr. Smith</option>
              <option value="2">Nurse Johnson</option>
            </select>
          </div>
        </div>
      </div>

      <div className="row g-4 mb-4">
        <div className="col-md-4">
          <div className="form-group">
            <label className="form-label text-muted mb-2">Appointment Type *</label>
            <select
              name="type"
              value={formData.type}
              onChange={handleChange}
              className={`form-select border-bottom border-light py-2 w-100 ${errors.type ? 'is-invalid' : ''}`}
            >
              <option value="">Select type...</option>
              <option value="checkup">Checkup</option>
              <option value="scan">Scan</option>
              <option value="consultation">Consultation</option>
            </select>
          </div>
        </div>
        
        <div className="col-md-4">
          <div className="form-group">
            <label className="form-label text-muted mb-2">Date *</label>
            <input
              type="date"
              name="date"
              value={formData.date}
              onChange={handleChange}
              className={`form-control border-bottom border-light py-2 px-0 ${errors.date ? 'is-invalid' : ''}`}
            />
          </div>
        </div>
        
        <div className="col-md-4">
          <div className="form-group">
            <label className="form-label text-muted mb-2">Time *</label>
            <input
              type="time"
              name="time"
              value={formData.time}
              onChange={handleChange}
              className={`form-control border-bottom border-light py-2 px-0 ${errors.time ? 'is-invalid' : ''}`}
            />
          </div>
        </div>
      </div>

      <div className="mb-4">
        <div className="form-group">
          <label className="form-label text-muted mb-2">Additional Notes</label>
          <textarea
            name="notes"
            value={formData.notes}
            onChange={handleChange}
            className="form-control bg-light border-0 rounded-3 p-3"
            rows="4"
            placeholder="Enter any additional information..."
          ></textarea>
        </div>
      </div>

      <div className="d-grid mt-5">
        <button 
          type="submit"
          className="btn btn-primary btn-lg py-3 fw-bold hover-effect w-100"
          disabled={!formData.patientId || !formData.staffId || !formData.type || !formData.date || !formData.time}
        >
          Schedule Appointment
        </button>
      </div>
    </form>
  );
}

export default AppointmentForm;